import { render } from "./TransactionHistory.vue?vue&type=template&id=19feb510&ts=true"
import script from "./TransactionHistory.vue?vue&type=script&lang=ts"
export * from "./TransactionHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__